module.exports = __webpack_public_path__ + "static/blog-4e89642068371f190c9e75769aacb1f2.svg";